<label class="switch" [ngClass]="{'disabled':disabled}">
    <input [type]="type" [name]="name" [value]="value" [checked]='checked' [(ngModel)]='value' (change)='valueEmitter.emit(checked);'>
    <span class="slider round" [ngClass]="{'disabled':disabled}"></span>
    <span class="check-text "><ng-content></ng-content></span>
</label>
